import { MappingSourceType } from "../../../../config/enums/MappingSourceType.enum";

/** What the user chose to remove. Drives the confirmation phrase, the button label and the endpoint. */
export enum DeleteMappingScope {
  CurrentVersion = "current-version",
  AllVersions = "all-versions"
}

/**
 * The dialog's behaviour is a total function of two facts: how many versions the mapping has,
 * and whether we know which one is active. Four combinations, four modes -- see
 * `resolveDeleteMode`, the single place that turns the two inputs into one of these.
 */
export enum DeleteMappingMode {
  /** More than one version, and we know which is active: both scopes are real choices. */
  Choice = "choice",
  /** Exactly one version, and we know which: removing it empties the mapping (T15). */
  LastVersion = "last-version",
  /** No version has been created yet: there is nothing for "current version only" to target. */
  NoVersionRow = "no-version-row",
  /** Versions exist but none is flagged active (a known backend anomaly): can't target just one. */
  NoDefaultVersion = "no-default-version"
}

export interface DeleteMappingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** The drawing tool id. Both scopes need it; the dialog is only rendered once a mapping is loaded. */
  drawingId: string | undefined;
  mappingSourceType: MappingSourceType;
  /** The active version's id -- the target of the current-version scope. */
  currentVersionId: string | undefined;
  /** Shown in the current-version helper text. */
  currentVersionNumber: number | undefined;
  /** Total versions this mapping has. Exactly 1 (with a currentVersionId) disables the all-versions scope. */
  versionCount: number;
  /** Hides the "remove all versions" option (supplier users may only remove the current version). */
  hideAllVersions?: boolean;
  onDeleted: (scope: DeleteMappingScope) => void;
}

export interface DeleteScopeRadioGroupProps {
  value: DeleteMappingScope;
  onChange: (scope: DeleteMappingScope) => void;
  currentVersionNumber: number | undefined;
  mode: DeleteMappingMode;
  disabled: boolean;
  hideAllVersions?: boolean;
}

export interface DeleteConfirmPhraseInputProps {
  value: string;
  onChange: (value: string) => void;
  requiredPhrase: string;
  disabled: boolean;
}
